"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JSON_CONTENT = void 0;
const JSON_CONTENT = exports.JSON_CONTENT = 'application/json';
